// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Pze7","name":"ConsentHeader_name__2Lpxw","birthday":"ConsentHeader_birthday__Jgd8P","skeleton":"ConsentHeader_skeleton__2Y8bK"};